import api from '@services/api';
import { BranchResponse } from '../models/branch';

/**
 * <p>
 * API endpoints that cover all branch related CRUD calls
 */
export const branchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    branchs: builder.query<BranchResponse[], void>({
      query: () => ({
        url: encodeURI(`/report/branch/list`),
      }),
      providesTags: ['Branchs'],
    }),
  }),
});

export const { useBranchsQuery } = branchApi;
